import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { ApiHook } from "../../hooks/apiHook";
import { toast } from "react-toastify";

const Reset2FA = () => {
  const params = useParams();
  const navigate = useNavigate();
  const verifyHashKey = ApiHook.CallVerify2FA({
    hash: params.hashKey,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        await verifyHashKey.mutateAsync(
          { hash: params.hashKey },
          {
            onSuccess: (res) => {
              if (res.status) {
                toast.success(res.data?.data?.message);
                navigate("/login");
              } else {
                toast.error(res?.data?.description);
                navigate("/login");
              }
            },
          }
        );
      } catch (error) {
        console.error("Error during mutation:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
    </>
  );
};

export default Reset2FA;